export enum AuthEntityType {
    Center = 10,
    DonorConnect = 20,
    LogisticsProvider = 30
}